import React, { useState } from 'react';

// Estilização
import { Card } from './styles';

// dica
import Tooltip from '@material-ui/core/Tooltip';

// icones
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import BusinessIcon from '@material-ui/icons/Business';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CloseIcon from '@material-ui/icons/Close';
import UndoIcon from '@material-ui/icons/Undo';

import Dialogoconfirmacao from '../Dialogoconfirmacao';
import Dialogoverprojeto from '../Dialogoverprojeto';

import Chatboxconfirm from '../Chatboxconfirm';
import { DELETE_RESPONSIBLES, PATCH_PROJECTS_REFUSE } from '../../services/endpoints';
import { useAuth } from '../../contexts/AuthContext';
import Dialogoadicionarsupervisor from '../Dialogoadicionarsupervisor';

function CardNovosProjetos(props) {
  const { user } = useAuth();
  const isAdmin = (user?.role === 'ADMINISTRADOR') || (user?.role === 'GERENTE');

  const [showbackdrop, setShowbackdrop] = useState(false);

  const [showconfdesvincular, setShowconfdesvincular] = useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: 'Deseja realmente desvincular este supervisor?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  const [showconf, setShowconf] = useState({
    status: false,
    width: 'sm',
    title: 'Recusar',
    description: 'Deseja realmente recusar este projeto?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  const [solicitarmud, setSolicitarmud] = useState({
    status: false,
    dados: '',
  });

  const [viewproject, setViewproject] = useState({
    status: false,
    dados: '',
  });

  // Modal de cadastro de Supervisor
  const [viewcadastrarsupervisor, setViewcadastrarsupervisor] = useState({
    status: false,
    dados: '',
  });

  const maisatual = (a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  };

  const sendWhatsapp = (phone) => {
    const clearedPhone = phone.replace(/\D/g, '');
    const url = `https://wa.me/${clearedPhone}`;

    window.open(url, '_blank');
  }

  return (
    <Card
      key={props.idx}
      refused={props.proj.refused}
      abaSelected={props.abaSelected}
    >
      <div className="div__name">
        <h4>
          <AssignmentOutlinedIcon /> {props.proj?.client_name}
        </h4>
        {props?.proj?.client_cnpj && (
          <h4>
            <BusinessIcon /> {props.proj?.client_name}
          </h4>
        )}
        {props.proj?.client_cpf && <span>CPF: {props.proj.client_cpf}</span>}
        {props.proj?.client_cnpj && <span>CNPJ: {props.proj.client_cnpj}</span>}
        <span>
          {props.proj.dealer.name} - {props.proj.dealer.state}
        </span>
        <h4>{props.proj.total_project_power} kWp</h4>
        <span>Solicitado em:</span>
        <p>{new Date(props.proj.created_at).toLocaleDateString('pt-BR')}</p>

        <span className="tag-whatsapp">
          {props?.proj?.receipts[0]?.is_whatsapp && (
            <p>Negociação pelo Whatsapp</p>
          )}
        </span>

        <span className="tag">
          {props?.proj?.responsibles.length !== 0 ? (
            <>
              <p>
                {props?.proj?.responsibles
                  .sort(maisatual)[0]
                  ?.user?.name.split(' ')
                  .map((item, idx) => idx < 2 && item + ' ')}{' '}
                -{' '}
                {props?.proj?.responsibles.sort(maisatual)[0]?.user?.role === "ADMINISTRADOR" ? "PROJETISTA" : props?.proj?.responsibles.sort(maisatual)[0]?.user?.role}
              </p>

              {!props?.proj?.finished_at && isAdmin && (
                <Tooltip
                  placement="bottom-start"
                  title="Remover supervisor"
                >
                  <HighlightOffIcon
                    style={{
                      color: 'var(--delete)',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      setShowconfdesvincular({
                        ...showconf,
                        status: true,
                        width: 'sm',
                        title: 'Confirmar',
                        description: `Deseja realmente desvincular o supervisor ${props?.proj?.responsibles.sort(maisatual)[0]
                            ?.user?.name
                          } do projeto ${props?.proj.client_name}?`,
                        btn_conf: 'Sim',
                        btn_cancel: 'Não',
                        delete: false,
                        dados: props?.proj,
                        type: 'DELETE_RESPONSIBLES',
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          ) : (
            <p
              style={{
                backgroundColor: 'var(--gray)',
                color: 'var(--primary)',
                cursor: 'pointer',
              }}
              onClick={() =>
                setViewcadastrarsupervisor({
                  status: true,
                  dados: props?.proj,
                })
              }
            >
              Adicionar Supervisor
            </p>
          )}
        </span>

        <div className="div__options">
          <Tooltip
            placement="bottom-start"
            title="Visualizar informações de projeto"
          >
            <button
              onClick={() =>
                setViewproject({ status: true, dados: props.proj })
              }
              className="button_icon"
            >
              <VisibilityOutlinedIcon />
            </button>
          </Tooltip>

          {!props.proj.refused && (
            <Tooltip
              placement="bottom-start"
              title="Confirmar Recepção do projeto"
            >
              <button
                onClick={() =>
                  setSolicitarmud({ status: true, dados: props.proj })
                }
              >
                <PlaylistAddCheckIcon />
              </button>
            </Tooltip>
          )}
          
          {props?.proj?.receipts[0]?.is_whatsapp && (
            <Tooltip
              placement="bottom-start"
              title="Negociar pelo WhatsApp"
            >
              <button
                onClick={() =>
                  sendWhatsapp(props?.proj?.integrators[0]?.integrator?.phone_numbers[0]?.number)
                }
              >
                <WhatsAppIcon />
              </button>
            </Tooltip>
          )}

          <Tooltip
            placement="bottom-start"
            title={
              !props.proj.refused ? 'Recusar projeto' : 'Reavaliar projeto'
            }
          >
            <button
              className={!props.proj.refused && 'button_delete'}
              onClick={() =>
                setShowconf((value) => ({
                  ...value,
                  status: true,
                  description: !props.proj.refused
                    ? 'Deseja realmente recusar este projeto?'
                    : 'Deseja realmente reavaliar este projeto? O projeto será movido para Novos Projetos.',
                  delete: !props.proj.refused,
                  dados: props.proj,
                }))
              }
            >
              {!props.proj.refused ? <CloseIcon /> : <UndoIcon />}
            </button>
          </Tooltip>
        </div>
      </div>

      {showconfdesvincular.status && (
        <Dialogoconfirmacao
          status={showconfdesvincular.status}
          width={showconfdesvincular.width}
          delete={showconfdesvincular.delete}
          description={showconfdesvincular.description}
          fechar={() =>
            setShowconfdesvincular({
              status: false,
              width: 'sm',
              title: 'Confirmar',
              description: 'Deseja realmente suspender este projeto?',
              btn_conf: 'Sim',
              btn_cancel: 'Não',
              delete: true,
              dados: '',
              type: 'DELETE_RESPONSIBLES',
            })
          }
          confirmar={async () => {
            await DELETE_RESPONSIBLES(
              showconfdesvincular.dados.responsibles[0].id,
              props.atualizar,
              setShowbackdrop
            );
          }}
        />
      )}

      {showconf.status && (
        <Dialogoconfirmacao
          status={showconf.status}
          width={showconf.width}
          delete={showconf.delete}
          description={showconf.description}
          fechar={() =>
            setShowconf((value) => ({ ...value, status: false, dados: '' }))
          }
          confirmar={() => {
            PATCH_PROJECTS_REFUSE(showconf.dados, props.atualizar);
          }}
        />
      )}

      {viewcadastrarsupervisor.status && (
        <Dialogoadicionarsupervisor
          dados={viewcadastrarsupervisor.dados}
          fechar={() =>
            setViewcadastrarsupervisor({ status: false, dados: '' })
          }
          atualizar={props.atualizar}
        />
      )}

      {viewproject.status && (
        <Dialogoverprojeto
          dados={{ ...viewproject.dados }}
          dados_edit={viewproject?.dados_edit}
          fechar={() => setViewproject({ status: false, dados: '' })}
          atualizar={props.atualizar}
          onProjectPixUpdated={props.onProjectPixUpdated}
          onProjectPaymentUpdated={props.onProjectPaymentUpdated}
        />
      )}

      {solicitarmud.status && (
        <Chatboxconfirm
          fechar={() => setSolicitarmud({ status: false, dados: '' })}
          dados={solicitarmud.dados}
        />
      )}
    </Card>
  );
}

export default CardNovosProjetos;
